import { DEFAULT_GETTERS } from '@/constants'

export default {
  ...DEFAULT_GETTERS,
  fileUrl: state => state.fileUrl,
  fileVideo: state => state.fileVideo,
}
